import { coverCommonNamesMap } from "./options"
import {Content, FilterType} from "./types"

export const classNames = (...classes: any[]) => {
	return classes.filter(Boolean).join(" ")
}

export const toCamelCase = (str: string) => {
	if (!str) return ""

	return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
		if (+match === 0) return ""
		return index === 0 ? match.toLowerCase() : match.toUpperCase()
	})
}

export const cleanString = (input: string) => {
	var output = ""

	for (var i=0; i<input.length; i++) {
		if (input.charCodeAt(i) <= 127) {
			output += input.charAt(i)
		}
	}

	return output
}

export const convertToFloat = (str: string): number => {
	let sign = "";

	const signMatch = /^\s*(-|\+)/.exec(str);
	if (signMatch) {
		sign = signMatch[1];
	}

	const updatedBody = str.replace(/[^\d.]/g, "");

	return parseFloat(sign + updatedBody);
}

export const getInsuranceCompanyName = (companyName: string) => {
	let returnValue: string = companyName

	switch ( companyName.toLowerCase() ) {
		case "pop":
			returnValue = "pop"
			break
		case "fennia":
			returnValue = "fennia"
			break
		case "pohjantähti":
			returnValue = "pohjantahti"
			break
		case "turva":
			returnValue = "turva"
			break
		case "lähitapiola":
			returnValue = "lahitapiola"
			break
		case "pohjola":
			returnValue = "pohjola"
			break
		case "pohjola vakuutus":
			returnValue = "pohjola"
			break
		default:
			returnValue = companyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
	}

	returnValue += ".png"

	return returnValue
}

export const getCommonName = (type: FilterType, name: string): string => {
	let returnValue: string = name
	let iterator

	switch (type) {
		case FilterType.LEVEL_OF_COVER:
			return name
		case FilterType.OPTIONAL:
			iterator = coverCommonNamesMap.entries()
			break
		case FilterType.RATING:
			return name
	}

	if (iterator) {
		let result = iterator.next()

		while (!result.done) {
			const [category, values] = result.value

			if (values.includes(name)) {
				returnValue = category
				break
			}

			result = iterator.next()
		}
	}

	return returnValue
}

export const processKey = (key: any): any[] => {
	const k = key.match(/([^.[\]])+/g)[0]
	const index = key.indexOf(k) + k.length

	return [k, key.substr(index)]
}

export const getValue = (key: any, data: any): Content => {
	const [k, rest] = processKey(key)

	if (rest) {
		return getValue(rest, data[k])
	}

	return data[k]
}
